let routes = [
    {
      path: '/inspection-professionnelle',
      component: () => import('../views/InspectionProfessionnelle.vue'),
      props: true
    },
    {
      path: '/inspection-professionnelle/:step',
      component: () => import('../views/InspectionProfessionnelle.vue'),
      props: true
    }
  ]
  
  export default routes;